import * as React from "react";
import styled from "@emotion/styled";
import {map} from "lodash";

interface IProps {
    className?: string;
    error?: string[] | null;
    errorOnBottom?: boolean;
}

interface IErrorMessageThemeProps {
    errorOnBottom?: boolean;
}

export const FormErrorMessage: React.FC<IProps> = (props: IProps) => {
    const errorMessage = props.error && map(props.error, (item: string | null, idx: number) => <span key={idx}>{item}</span>);

    return (
        <ErrorMessage className={props.className} errorOnBottom={props.errorOnBottom}>
            {errorMessage}
        </ErrorMessage>
    );
};

/*
Styles
 */

const ErrorMessage = styled.div<IErrorMessageThemeProps>`
    color: ${(props) => props.theme?.forms?.error_message_color ?? "#ff5a5f"};
    font-size: ${(props) => props.theme?.forms?.error_message_font_size ?? "1rem"};
    text-align: left;
    line-height: ${(props) => props.theme?.forms?.error_message_line_height ?? 1.5};
    text-transform: lowercase;
    padding-bottom: ${(props) => props.theme?.forms?.error_message_padding_bottom ?? ".5rem"};
`;
